import React from 'react';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { VerificationScreen } from './verificationScreen';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => ({
    userProfile: state.userProfile,
    userProfileForm: state.userProfileForm,
});

const mapDispatchToProps = dispatch => ({
    formActions: bindActionCreators(formActions, dispatch),
});

export const VerificationScreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(props => {
    return <VerificationScreen {...props} />;
});
